import { getViewConfig } from './ViewConfig';
import { mergeRefs } from './useRefs';
import { DYNAMIC_LAYER } from '../../css/core/constants';
import { addIntent } from '../../../intent';
function createListPropertyProcessor(merge) {
    return function setListProperty(value, target, property) {
        const config = getViewConfig(target);
        if (!config.state[property]) {
            config.state[property] = {
                list: [],
                merged: []
            };
        }
        const state = config.state[property];
        const cache = config.cache[property];
        const index = state.list.length;
        if (typeof value !== 'undefined') {
            state.list.push(value);
        }
        if (cache && cache !== state && cache.list[index] === value) {
            state.merged.push(cache.merged[index]);
        } else {
            state.merged.push(index === 0 ? value : merge(state.list));
            config.cache[property] = state;
        }
        config.props[property] = state.merged[index];
    };
}
export const setEvent = createListPropertyProcessor((clonedHandlers)=>function mergedEvent(event) {
        for(let i = 0; i < clonedHandlers.length; i++){
            clonedHandlers[i](event);
        }
    });
export const setRef = createListPropertyProcessor(mergeRefs);
export const setCss = (value, facade)=>{
    const config = getViewConfig(facade);
    if (value && config.css) {
        addIntent(config, config.css[DYNAMIC_LAYER](value));
    }
};

//# sourceMappingURL=propertyProcessors.js.map